var map = {
	"./half-circles.svg": "d4a4",
	"./logo-icon.svg": "f00c",
	"./logo-text.svg": "f903",
	"./plus.svg": "4eb1",
	"./social-discord.svg": "e8c7",
	"./social-facebook.svg": "b477",
	"./social-instagram.svg": "c692",
	"./social-linkedin.svg": "71e9",
	"./social-twitter.svg": "8044",
	"./social-youtube.svg": "9e79",
	"./sound-off.svg": "be1c",
	"./sound-on.svg": "362f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4555";